import React from "react";

const importTabComponent = () => {
  return <div></div>;
};

export default importTabComponent;
